import * as React from "react";

;
export const Indicator = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} fill="none" {...props}><path fill="currentColor" d="M0 0h10v10H0z" /></svg>;